jQuery(document).foundation();

jQuery('.__date').flatpickr( {
  altInput: true,
  altFormat: "F j, Y",
  dateFormat: "F j, Y",
} );

jQuery( '.__overflow' ).niceScroll( {
  background: '#e2eff9',
  cursorwidth: 10,
  cursorcolor: '#00457c',
  cursorborder: 0,
  cursorborderradius: 5,
  autohidemode: false
} );